module.exports = __webpack_public_path__ + "img/of_ic_comment_rider@2x.f071b5d7.png";